import { Box, Checkbox, Button as SButton } from '@atgfr8/atg-ui-tailwind';
import { BasicModal, Button } from '@components';
import { closeModal, openModal } from '@store/modals';
import {
  customerStore,
  loadTenderStore,
  orderStore,
  unlinkEDITender,
  updateOrderState,
} from '@store/orders';
import { FormatListBulletedIcon, LockOpenIcon } from '@atgfr8/icons';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { printLog } from '@utils/utils';
import {
  EDI_LOAD_TENDER_ID,
  EDI_LOGS_ID,
  UNLINKED_EDI_TENDER_ID,
} from '@views/order/constants';
import { Show, createSignal } from 'solid-js';

import { EdiLog } from '../models/EdiLog';
import classes from './classes';
import { EDILoadTender } from './EDILoadTender';

const CustomerEDI = () => {
  const cls = classes.customerInfo;
  const [hideX6, setHideX6] = createSignal<boolean>(false);
  const unlinkEDILoadTender = async () => {
    try {
      await unlinkEDITender(
        loadTenderStore.loadTender?.shipmentId,
        orderStore.order.id.toString(),
      ).then(() => {
        updateOrderState({ loadTenderId: null });
        closeModal(UNLINKED_EDI_TENDER_ID);
      });
    } catch (err) {
      printLog(err);
    }
  };

  const EdiModalTitle = () => {
    return (
      <Box class="ml-10">
        <Checkbox
          label="Hide(X6)En Route Updates"
          checked={hideX6()}
          onChange={() => setHideX6(!hideX6())}
          dataTestId={formatDataTestId(
            'Hide(X6)En Route Updates',
            'checkboxInput',
          )}
          size="xs"
          color="info"
          class="ml-[-9px]"
        />
      </Box>
    );
  };

  return (
    <Show when={customerStore.customer.edi}>
      <div class="flex mb-[5px] mt-[15px]">
        <div class="mobile:hidden nonMobile:flex flex-1 h-[38px] max-w-[280px] mr-[56px]">
          <Button
            variant="contained"
            label="VIEW LOAD TENDER"
            sx={{
              'margin-left': '0px',
              width: '100%',
              'border-radius': '4px 0px 0px 4px',
            }}
            onClick={() => openModal(EDI_LOAD_TENDER_ID)}
            disabled={!Boolean(orderStore.order.loadTenderId)}
            dataTestId={formatDataTestId('VIEW LOAD TENDER', 'button')}
          />
          <SButton
            variant="contained"
            dataTestId="unlink-edi-tender-button"
            disabled={!Boolean(orderStore.order.loadTenderId)}
            sx={{
              'border-left': '1px solid white',
              'border-radius': '0px 4px 4px 0px',
            }}
            onClick={() => openModal(UNLINKED_EDI_TENDER_ID)}
          >
            <LockOpenIcon class="text-white" />
          </SButton>
        </div>
        <div class="mobile:hidden nonMobile:block">
          <Button
            variant="contained"
            label="VIEW EDI LOG"
            startIcon={<FormatListBulletedIcon size={20} />}
            sx={{ 'margin-left': '10px', flex: '1' }}
            onClick={() => openModal(EDI_LOGS_ID)}
            dataTestId={formatDataTestId('VIEW EDI LOG', 'button')}
          />
        </div>
      </div>

      <BasicModal
        id={UNLINKED_EDI_TENDER_ID}
        header={false}
        width={'700px'}
        onClose={() => closeModal(UNLINKED_EDI_TENDER_ID)}
        onSubmit={() => unlinkEDILoadTender()}
        showClose={false}
        footer={true}
      >
        <span class={cls.unlinkText}>
          Are you sure you want to unlink the load tender from this Order? Doing
          so may cause EDI Updates and Invoices not to work properly.
        </span>
      </BasicModal>
      <EDILoadTender />

      <BasicModal
        id={EDI_LOGS_ID}
        title={'EDI Transaction History'}
        width={'1000px'}
        onClose={() => closeModal(EDI_LOGS_ID)}
        footer={false}
        customizedHeaderContent={<EdiModalTitle />}
      >
        <EdiLog hideX6={hideX6} />
      </BasicModal>
    </Show>
  );
};

export default CustomerEDI;
